import React from "react";
import { HeaderWrap } from "./elements";
import { SPHeader } from "./SPHeader";
import { PCHeader } from "./PCHeader";

export const MenuLabelList = [
  {
    link: "/",
    label: "トップページ",
  },
  {
    link: "/pickup_instructions",
    label: "ヤマトの集荷について",
  },
  {
    link: "/agreement",
    label: "ご利用規約",
  },
  {
    link: "/faq",
    label: "よくある質問",
  },
];

export const Header: React.FC = React.memo(() => {
  return (
    <HeaderWrap>
      <SPHeader />
      <PCHeader />
    </HeaderWrap>
  );
});

Header.displayName = "Header";
